export const MIRROR = [
  ['.kiev.ua', '.kyiv.ua'],
  ['.od.ua', '.odessa.ua', '.odesa.ua'],
  ['.mk.ua', '.nikolaev.ua', '.mykolaiv.ua'],
  ['.rivne.ua', '.rovno.ua'],
  ['.chernivtsi.ua', '.chernovtsy.ua'],
  ['.chernigov.ua', '.chernihiv.ua'],
  ['.dp.ua', '.dnepropetrovsk.ua', '.dnipropetrovsk.ua'],
  ['.uzhhorod.ua', '.uzhgorod.ua'],
];

export const SPECIAL = ['.ua', '.eu', '.travel', '.bg'];

export const MIRROR_UA = {
  '.uzhgorod.ua': '.uzhhorod.ua',
  '.cherkassy.ua': '.cherkasy.ua',
  '.chernigov.ua': '.chernihiv.ua',
  '.chernovtsy.ua': '.chernivtsi.ua',
  '.odessa.ua': '.odesa.ua',
  '.kiev.ua': '.kyiv.ua',
  '.kharkov.ua': '.kharkiv.ua',
  '.nikolaev.ua': '.mykolaiv.ua',
  '.rovno.ua': '.rivne.ua',
  '.kirovograd.ua': '.kropyvnytskyi.ua'
}
